// removed by extract-text-webpack-plugin
module.exports = {"linkBlue":"#0076C0","borderGray":"#d9d9d9","xs":"undefined","sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","container":"container-14LmF","closeButton":"closeButton-29bsC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/RouteSelector/_routeSelectModal.css
// module id = 1257
// module chunks = 1